export default __webpack_public_path__ + "6b942b57720983a7667e5e7e415b538c.jpg";